export enum EvidencesTypeEnum {
  IMAGE = 'image',
  VIDEO = 'video',
  SIGN = 'sign',
  COMMENT = 'comment',
  CAMERA = 'camera',
  VIDEO_GALLERY = 'video_gallery',
  FILE = 'file',
  OBSERVATION_COMMENT = 'observation_comment'
}

export enum EvidencesTypeValueEnum {
  IMAGE = 1,
  VIDEO = 2,
  SIGN = 3,
  DOCUMENT = 4,
  COMMENT = 5,
  CAMERA = 6,
  VIDEO_GALLERY = 7,
  OBSERVATION_COMMENT = 8,
}

export type EvidencesString = 'image' | 'video' | 'sign' | 'comment' | 'camera' | 'video_gallery' | 'file'
